import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaSpinner } from 'react-icons/fa';
const VARIANT_CLASSES = {
    primary: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    secondary: 'bg-gray-200 hover:bg-gray-300 text-gray-800',
    danger: 'bg-red-600 hover:bg-red-700 text-white',
    success: 'bg-green-600 hover:bg-green-700 text-white',
    warning: 'bg-yellow-500 hover:bg-yellow-600 text-white',
    info: 'bg-blue-500 hover:bg-blue-600 text-white',
};
const SIZE_CLASSES = {
    sm: 'px-2.5 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
};
const Button = ({ variant = 'primary', size = 'md', icon, loading = false, disabled, className = '', children, type = 'button', ...rest }) => {
    return (_jsxs("button", { 
        // eslint-disable-next-line react/button-has-type
        type: type, disabled: disabled || loading, className: `inline-flex items-center justify-center rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${className}`, ...rest, children: [loading ? (_jsx(FaSpinner, { className: "mr-2 animate-spin", "aria-hidden": "true" })) : (icon && _jsx("span", { className: "mr-2", children: icon })), children] }));
};
export default Button;
